import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { AuthService } from '../auth/auth.service';
import { ConfigService } from '../services/config.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService } from './loading.service';
import { NgxSpinner } from 'ngx-spinner/lib/ngx-spinner.enum';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
    providedIn: 'root'
})
export class InactivityService {
    private timeoutId: any;
    private readonly timeout: number = 15 * 60 * 1000; // 15 minutos

    constructor(private router: Router, private ngZone: NgZone, private loadingService: LoadingService, private spinner: NgxSpinnerService,
        public local: LocalStorageService, public authService: AuthService, private configService: ConfigService,
    public modalService: NgbModal) {
        this.startTimer();
        this.setupListeners();
    }

    private startTimer() {
        this.ngZone.runOutsideAngular(() => {
            this.timeoutId = setTimeout(() => this.logout(), this.timeout);
        });
    }

    private resetTimer() {
        clearTimeout(this.timeoutId);
        this.startTimer();
    }

    private setupListeners() {
        document.addEventListener('mousemove', () => this.resetTimer());
        document.addEventListener('keydown', () => this.resetTimer());
        document.addEventListener('click', () => this.resetTimer());
    }

    private logout() {
        this.ngZone.run(() => {
            this.spinner.hide();
            this.loadingService.hide(); 
            this.modalService.dismissAll();        
            this.router.navigate(['/inicio/login']);
        });
    }
}